import React from 'react';

import useEventTracking from '@hooks/useEventTracking';
import { newsletter_landing_path, titv_path } from '@routes';
import { ClickTarget, TrackingLocation, click } from '@tracking';
import { LeadTypes } from '@utils/enums';

import NewsletterSignupCard from './NewsletterSignupCard';
import Partners from './Partners';
import StreamingChannels from './StreamingChannels';
import { THE_INFORMATION_AM } from './constants';
import type { DailyShowDescriptionProps } from './interfaces';

const DailyShowDescription = ({ partnerAds, signupNewsletter }: DailyShowDescriptionProps) => {
  const { trackEvent, Track } = useEventTracking({
    location: TrackingLocation.TITVDescription,
  });

  return (
    <Track>
      <div className="mb-20 flex flex-wrap items-center justify-center gap-20 sm:mb-40 sm:flex-nowrap sm:justify-between">
        <div className="mb-16 w-full lg:w-2/3">
          <h1 className="m-0 mb-3 font-suisse-screen text-headline-alt-sm sm:text-headline-alt-md lg:text-headline-alt-lg">
            The Information’s TITV
          </h1>
          <div className="font-suisse-intl-mono text-overline-md sm:text-overline-lg">
            Weekdays at 10 am PT / 1 pm ET
          </div>
          <div className="my-32 max-w-full sm:max-w-[719px]">
            <p className="m-0 mb-8 font-suisse-neue text-body-lg">
              The Information’s TITV is first in tech news and analysis from the people that break
              and shape the story. The rest is just commentary.
            </p>
            <p className="m-0 mb-8 font-suisse-neue text-body-lg">
              Watch every weekday at 10 am PT/1 pm ET on The Information.com, App, YouTube, X—and on
              demand wherever you get your podcasts.
            </p>
            <p className="m-0 mb-8 font-suisse-neue text-body-lg">
              Sign up for{' '}
              <a
                href={newsletter_landing_path('the-information-am')}
                className="text-primary-magenta underline transition-colors hover:text-primary-pink dark:text-primary-pink dark:hover:text-primary-magenta"
                onClickCapture={() =>
                  trackEvent(
                    click({ clickTarget: ClickTarget.Link, clickText: THE_INFORMATION_AM })
                  )
                }
              >
                {THE_INFORMATION_AM}
              </a>{' '}
              for the most important global tech news of the day.
            </p>
          </div>
        </div>
        <div className="flex w-full flex-col gap-32 sm:w-1/3 sm:shrink-0 lg:w-1/4">
          <div className="mx-auto w-fit">
            <StreamingChannels />
          </div>
          {signupNewsletter && (
            <NewsletterSignupCard
              leadType={LeadTypes.TITVDailyShowNewsletterSignup}
              newsletter={signupNewsletter}
              redirectToOnSuccess={titv_path()}
            />
          )}
        </div>
      </div>
      {!!partnerAds?.length && <Partners partnerAds={partnerAds} />}
    </Track>
  );
};

export default DailyShowDescription;
